import axios from '@/app/axios'
import CrudService from '@/common/services/crud-service'
import User from '@/users/entities/user'
import Responses from '@/app/utils/responses'

class UsersService extends CrudService<User> {
  public async export(
    search: string,
    onlyNewsletter: boolean,
    status: string,
    notInvoiced: boolean
  ): Promise<Blob> {
    const res = await axios.get(
      `${this.resource}/export?search=${search}&onlyNewsletter=${onlyNewsletter}&status=${status}&notInvoiced=${notInvoiced}`
    )
    return Responses.obj(res)
  }
}

export default new UsersService('users')
